export const isEmptyObject = (toCheck: unknown) => {
    return toCheck === null || toCheck === undefined;
};
